import { HttpClient } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { markAllAsDirtyAndTouched } from '../../shared/functions';

@Component({
    selector: 'app-fale-conosco',
    standalone: false,
    templateUrl: './fale-conosco.component.html',
    styleUrl: './fale-conosco.component.scss'
})
export class FaleConoscoComponent
{
    private formBuilder = inject(FormBuilder);
    private http = inject(HttpClient);
    public sendSuccessfull = signal<boolean | null>(null);
    public isLoading = signal<boolean>(false);

    public form: FormGroup = this.formBuilder.group({
        nome: [null, [Validators.required]],
        email: [null, [Validators.required, Validators.email]],
        mensagem: [null, [Validators.required]]
    })

    public async sendEmail(): Promise<void>
    {
        markAllAsDirtyAndTouched(this.form);

        if (this.form.invalid)
            return;
        try
        {
            this.isLoading.set(true);
            await lastValueFrom(this.http.post(environment.apiUrl + '/fale-conosco', this.form.value));
            this.sendSuccessfull.set(true);
        }
        catch (e)
        {
            this.sendSuccessfull.set(false);
            console.log(e)
        }
        finally
        {
            this.isLoading.set(false);
            this.form.reset();
        }
    }

    public tryAgain(): void
    {
        this.sendSuccessfull.set(null);
    }
}